import { makeShowMoralField } from '../../../../personType/logic/show';
export var showLogic = makeShowMoralField({});
